<apcam-shared-dialog-shell [config]="dialogShellConfig">
    <p>{{ data.detail }}</p>
    <mat-form-field class="w-full">
        <mat-label>{{ data.inputLabel }}</mat-label>
        <textarea
            matInput
            [formControl]="comment"
            [placeholder]="data.commentPlaceholder"></textarea>
    </mat-form-field>
</apcam-shared-dialog-shell>
